import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { WindowRefService } from '../../share/services/window-ref.service';
import { isDrupalAnonymousUser } from '../../share/utils/is-drupal-anonymous-user';

/**
 * Drupal renders the Northway account page for signed-out visitors too, and the tag on it asks
 * for ?app=/account. With the anonymous user in window.metaData there is no account to show, so
 * the route goes back to the empty root instead of opening the account modal.
 */
export const drupalUserSignedIn: CanActivateFn = ({ queryParams }: ActivatedRouteSnapshot) => {
  const windowRef = inject(WindowRefService);
  const router = inject(Router);

  if (isDrupalAnonymousUser(windowRef.nativeWindow?.metaData?.user)) {
    return router.createUrlTree(['/'], { queryParams });
  }

  return true;
};

export default drupalUserSignedIn;
